/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { CustomTable } from '@zeeve-platform/table-component';
import Urls from '../../utils/urls';
import apiBackendInstance from '../../utils/axios';

export type NetworkInviteDataDB = {
  id?: string,
  network_id?: string,
  network_name: string,
  status: number,
  protocol_id?: string,
  sender_email: string,
  reciever_email: string,
  redirection_url: string,
  created_at: string,
  updated_at?: string
};

const NetworkInviteBody = () => {
  const [tdata, setTData] = useState([] as NetworkInviteDataDB[]);
  const getAllNetworkInviteList = () => {
    apiBackendInstance.get(Urls.getNetworkInviteList(0), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data) {
        setTData(response.data.data);
      }
    })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  };

  useEffect(() => {
    getAllNetworkInviteList();
  }, []);

  const columns = [
    {
      name: 'Network Name',
      selector: (row: any) => row.network_name,
      grow: 2,
    },
    {
      name: 'Status',
      cell: (row: any) => [row.status === 0 ? 'Pending' : row.status === 1 ? 'Accepted' : 'Rejected'],
    },
    {
      name: 'Reciever Email',
      selector: (row: any) => (row.reciever_email),
    },
    {
      name: 'Created At',
      selector: (row: any) => moment(row.created_at).format('lll'),
    },
    {
      name: 'Action',
      selector: (row: any) => [<a href={`${row.redirection_url}${row.redirection_url.includes('?') ? '&' : '?'}notificationId=${row.id}`}><button className="btn btn-success" type="button">View Details</button></a>],
    },
  ];
  return (
  <div>
     <div className="mt-2 row">
            <CustomTable
              data={tdata}
              columns={columns}
              showPagination={false}
              isLoading={false}
              isLoadingElement="Loading..."
               title=""
            //    serverSidePagination={
            //     {
            //       paginationTotalRows: 100,
            //       onChangeRowsPerPage: () => {},
            //       onChangePage: () => {},
            //     }
            // }
            />
     </div>
  </div>
  );
};

export default NetworkInviteBody;